"use client";

import type { Square } from "chess.js";
import { Board2D } from "@/components/board/Board2D";
import type { BoardRules } from "@/components/board/interaction";

const STATIC: BoardRules = { legal: [] };

/** A still variant position. Pieces are read from the FEN, so pockets and Horde setups render. */
export function VariantDiagram({ fen, caption, tint = [], orientation = "white" }: { fen: string; caption: string; tint?: string[]; orientation?: "white" | "black" }) {
  const tints = Object.fromEntries(tint.map((sq) => [sq, "rgba(215, 154, 118, 0.45)"])) as Partial<Record<Square, string>>;
  return <figure className="variant-diagram">
    <Board2D fen={fen} rules={STATIC} tints={tints} orientation={orientation} label={caption} />
    <figcaption>{caption}</figcaption>
  </figure>;
}
